import { Typography, MenuItem, TextField, CircularProgress, Stack, Button, Box, FormControlLabel, Checkbox,  Dialog, DialogContent, DialogTitle, DialogActions, Backdrop, IconButton } from "@mui/material";
import React, {useEffect, useState, useContext, useMemo} from "react";
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { useNavigate } from "react-router-dom";
import { Context } from "../App";
import { API } from "../conf";
import moment from 'moment';
import Header from "./Header";
import PaymodeForm from "./pay-mode-form";
import { COMPTES_DE_CHARGES } from "../asset/variables";

export default function RegistDepense(props) {
    const navigate = useNavigate()
    const { updateConnect } = useContext(Context)
    const [organisation, setOrganisation] = useState()
    const [agent, setAgent] = useState()
    const [eglises, setEglises] = useState([])
    const [egliseId, setEgliseId] = useState('')
    const [loading, setLoad] = useState(true)
    const [sending, setSend] = useState(false)
    const [open, SetOpen] = useState(false)
    const [open_choice, SetOpenChoice] = useState(false)
    const [comptes, setComptes] = useState([])
    const [uncloture_months, setUncloture_months] = useState([])
    const [reptotal, setReptotal] = useState(props.depense?.paymode? (props.depense.paymode.especes+props.depense.paymode.cheques?.reduce((tt, cq)=>tt+cq.montant,0)+(props.depense.paymode.virement?.montant??0)):0)
    
    const [date, setDate] = useState(props.depense?.date? moment.utc(props.depense.date).format('yyyy-MM-DD'):'')
    const [compteNum, setCompte] = useState(props.depense?.comptes?.length>0 ? props.depense.comptes[0] : '')
    const [classe, setClasse] = useState(props.depense?.class??'')
    const [fournisseur, setFournisseur] = useState(props.depense?.fournisseur??'')
    const [label, setLabel] = useState(props.depense?.libelle??'')
    const [num_facture, setFactnum] = useState(props.depense?.num_facture??'')
    const [montant, setMontant] = useState(props.depense?.montant??0)
    const [facture_files, setFiles] = useState([''])
    const [banque, setBanque] = useState('')
    const [is_petite_caisse, setPetiteCaisse] = useState(false)
    
    const [pay_mode, setMode] = useState(props.depense?.paymode? Object.keys(props.depense?.paymode).filter(key=>{
        switch (key) {
            case 'especes':
                return props.depense.paymode.especes>0
            case 'cheques':
                return props.depense.paymode.cheques?.length>0
            case 'virement':
                return props.depense.paymode.virement?.montant>0
            default:
                return false
        }
    }):[''])
    const [especes, setEspeces] = useState(props.depense?.paymode?.especes??0)
    const [repCheques, setRepCheques] = useState(props.depense?.paymode?.cheques??[{banque:'', montant:0, num_cheque:''}])
    const [repVir, setRepVir] = useState(props.depense?.paymode?.virement?{...props.depense.paymode.virement, date: moment.utc(props.depense.paymode.virement.date).format('yyyy-MM-DD')}:{date:"", montant:0, ref: ''})

    const eglise = useMemo(()=>!organisation?.isFederation&&!organisation?.isUnion?organisation:eglises.find(eg=>eg._id===(props.edit?props.depense?.eglise:egliseId)),[egliseId,eglises,organisation, props.edit,props.depense?.eglise])
    const compte = useMemo(()=>comptes.find(c=>c.num===compteNum),[compteNum, comptes])

    async function handleSubmit() {
        setSend(true)
        SetOpen(false)
        const depense = {
            date: date,
            comptes: [compteNum, banque, is_petite_caisse?comptes.find(cp=>cp.type==='petite-caisse').num:''].filter(cpt=>cpt!==''),
            libelle: label,
            montant: montant,
            class: classe,
            fournisseur: fournisseur,
            num_facture: num_facture,
            paymode: JSON.stringify({
                especes: especes,
                cheques: repCheques.filter(cheque=> cheque.montant>0),
                virement: repVir.montant>0 ? repVir : {},
            }),
            eglise: eglise.number
        }
        let formdata = new FormData()
        for (let key in depense) {
            formdata.append(key, depense[key]);
        }
        const facture = facture_files.filter(f=> f!=='')
        for (let index = 0; index < facture.length; index++) {
            formdata.append('file', facture[index])
        }
        
        fetch(API.concat(props.edit? `/depenses/${props.depense?._id}/${JSON.stringify({montant: props.depense?.montant, especes: props.depense?.paymode?.especes, eglise: eglise.number, date: date})}`
            :`/depenses/create/${eglise._id}/${(new Date(date)).getUTCFullYear()}`), {
            method: props.edit? 'PATCH':'POST',
            headers:{'Authorization': 'Bearer ' + sessionStorage.getItem('token')},
            body: formdata
        }).then(async(response) => {
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200)  {
                    if (props.edit) {
                        const json = await response.json()
                        props.setDepenses(json)
                        props.close()
                    } else SetOpenChoice(true)
                }
                setSend(false)
            }
        })
    }

    function handleImport(event, index) {
        event.preventDefault();
        if (event.target.files.length>0) {
            const file = event.target.files[0]
            if (!facture_files.some(f => f.name===file.name && f.size===file.size && f.lastModified===file.lastModified)) {
                setFiles(old => {let newFiles=[...old]; newFiles[index]=event.target.files[0]; return newFiles})            
            }
        }
    }

    useEffect(()=>{
        if(eglise) {
            setLoad(true)
            fetch(API.concat(`/eglises/${eglise.number}/cloture`),{
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async response => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const {clotures, oldestUncloture} = await response.json()
                        if ((oldestUncloture && new Date(oldestUncloture) instanceof Date && !isNaN(new Date(oldestUncloture)))||clotures.length>0) {
                            const currentDate = new Date()
                            const oldestDate = oldestUncloture && new Date(oldestUncloture) instanceof Date && !isNaN(new Date(oldestUncloture)) ? new Date(oldestUncloture) : clotures.reduce((min, currentMonth) => (new Date(currentMonth.date) < new Date(min.date)) ? new Date(currentMonth.date) : new Date(min.date))
                            if (currentDate.getFullYear()>oldestDate.getFullYear()) {
                                const months = [
                                    ...Array.from({ length: 11-oldestDate.getMonth()+1 }, (_, i) => i+oldestDate.getMonth()), 
                                    ...Array.from({ length: currentDate.getMonth() + 1 }, (_, i) => i)
                                ].filter(month=>!clotures.some(cloture=>new Date(cloture.date).getMonth()===month))
                                setUncloture_months(months.length>2?months.slice(0,2):months)
                            } else {
                                const months = Array.from({ length: currentDate.getMonth() - oldestDate.getMonth()+1 }, (_, i) => i+oldestDate.getMonth())
                                .filter(month=>!clotures.some(cloture=>new Date(cloture.date).getMonth()===month))
                                setUncloture_months(months.length>2?months.slice(0,2):months)
                            }
                        }else {
                            const currentMonth = new Date().getMonth(); // 0 indexed (janvier = 0)
                            const months = Array.from({ length: currentMonth + 1 }, (_, i) => i)
                            setUncloture_months(months)
                        }
                    }
                }
            })
            fetch(API.concat(`/comptes/by/${JSON.stringify({eglise: eglise.number})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const comptes = await response.json()
                        setComptes(comptes); 
                        setLoad(false)
                    }
                }
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eglise])

    useEffect(()=>{
        if (organisation?.isFederation) {
            setLoad(true)
            fetch(API.concat(`/eglises/by/${JSON.stringify(agent.eglises?.length>0 ? {number:{$in: agent.eglises}}:{isFederation: false, isUnion: false})}`), {
                method:'GET',
                headers:{
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('token')
                }
            }).then(async(response) => {
                const token = response.headers.get('x-auth-token')
                if(response.status === 401) {
                    sessionStorage.clear()
                    updateConnect(false)
                }else {
                    if (token && token !== sessionStorage.getItem('token') && token !== '') {
                        sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                    }
                    if (response.status === 200) {
                        const json = await response.json()
                        setEglises(json)
                        setLoad(false)
                    }
                }
            })
        }
    },[agent,organisation])

    useEffect(()=>{
        setOrganisation(JSON.parse(sessionStorage.getItem('eglise')))
        setAgent(JSON.parse(sessionStorage.getItem('user')))
    },[])

    const currentDate = new Date()
    const comptes_filter = ['banque', 'petite-caisse',(agent?.level<3? 'liaison': '')].filter(e=>e!=='')
    return(
        <div style={{display:'flex', flexDirection:'column', paddingBottom:'30px'}}>
            {!props.edit&&<Header/>}
            <Typography sx={{textAlign:'center', marginTop:'20px', fontSize:26}}>Enregistrement des dépenses</Typography>
            {organisation?.isFederation&&!props.edit&&<TextField select size="small" label='Église' sx={{minWidth:'300px', width:'20%', alignSelf:'end', marginRight:3}} value={egliseId} onChange={e=>setEgliseId(e.target.value)}>
                {eglises.sort((a,b)=>a.nom.toLowerCase()<b.nom.toLowerCase() ? -1 : 1).map(item=><MenuItem key={item._id} value={item._id}>{item.nom} - {item.commune.toUpperCase()}</MenuItem>)}
            </TextField>}
            {eglise&&<Box component={'form'} sx={{paddingX:'20px', marginTop:'20px', display:"flex", flexDirection:'column', width:'70%', minWidth:'500px', alignSelf:'center'}}>
                <Stack spacing={2} >
                    <Stack direction='row' sx={{justifyContent:'space-between', alignItems:'baseline'}} >
                        <TextField
                        variant="standard"
                        required
                        sx={{width:'60%', minWidth:'250px'}}
                        label="Libellé"
                        value={label}
                        onChange={(e)=>setLabel(e.target.value)}/>
                        <TextField
                        sx={{minWidth:'120px'}}
                        required
                        size="small"
                        type="date"
                        label={"Date"}
                        InputLabelProps={{shrink: true}}
                        inputProps={{
                            max: new Date().toISOString().split("T")[0], 
                            min: new Date(`01/01/2025`).toISOString().split("T")[0]}}
                            // min: uncloture_months.length>0? new Date(`${String(uncloture_months[0]+1).padStart(2, '0')}/01/${currentDate.getFullYear()+(currentDate.getMonth<uncloture_months[0]?1:0)}`).toISOString().split("T")[0]: null}}
                        value={date}
                        onChange={(e)=>{if(moment.utc(e.target.value).isSameOrAfter(moment.utc('2025-01-01'))&&moment.utc(e.target.value).isSameOrBefore(moment()))setDate(e.target.value)}}/>
                    </Stack>

                    <Stack direction='row' spacing={2}>
                        <TextField
                        id="outlined-select-currency"
                        fullWidth
                        required
                        select
                        label="Classification"
                        value={classe}
                        onChange={(event)=> setClasse(event.target.value)}
                        >
                            {COMPTES_DE_CHARGES.map((item, index) => (
                                <MenuItem key={index} value={item.libelle}>
                                    <Typography sx={{}}>{item.libelle}</Typography> 
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                        fullWidth
                        margin="normal"
                        label="Fournisseur"
                        value={fournisseur}
                        onChange={(e)=>setFournisseur(e.target.value)}/>
                    </Stack>
                    
                    <Stack direction='row' spacing={2}>
                        <TextField
                        id="outlined-select-currency"
                        fullWidth
                        select
                        label="Compte à débiter"
                        value={compteNum}
                        SelectProps={{renderValue:(()=>{
                            const compte = comptes.find(c=>c.num===compteNum)??''
                            return <Typography sx={{textTransform:'capitalize'}}>{compte.libelle}<br/><span style={{fontSize:12, color:'grey'}}>compte n°{compte.num_compte}</span></Typography>
                        })}}
                        onChange={(event)=> setCompte(event.target.value)}
                        >
                            {loading ?
                            <Box display='flex' justifyContent='center' alignItems='center'>
                                <CircularProgress />
                            </Box>
                            :comptes.filter(cp=>!comptes_filter.includes(cp.type)).map((compte, index) => (
                                <MenuItem key={index} value={compte.num} sx={{justifyContent:'space-between'}}>
                                    <Typography sx={{textTransform:'capitalize'}}>{compte.libelle}<br/><span style={{fontSize:12, color:'grey'}}>compte n°{compte.num_compte}</span></Typography> 
                                    <Typography sx={{textTransform:'capitalize'}}>{compte.solde?.toFixed(2)}€</Typography> 
                                </MenuItem>
                            ))}
                        </TextField>
                        <TextField
                        fullWidth
                        sx={{height:'100%'}}
                        InputProps={{style:{height:'100%'}}}
                        name="montant"
                        label="Montant (en €)"
                        inputProps={{step:"0.01", min:'0'}}
                        type="number"
                        onFocus={()=>{if(montant===0) setMontant('')}}
                        value={montant}
                        onChange={(e)=>{if (/^\d+(\.\d{1,2})?$/.test(e.target.value)&&Number(e.target.value)>=0){
                            setMontant(Number(e.target.value))
                        }else if(e.target.value===''){
                            setMontant('')
                        }}}/>
                    </Stack>
                </Stack>
                
                {montant>0 && <PaymodeForm 
                isdepense={true}
                total={montant}
                reptotal={reptotal}
                setReptotal={setReptotal}
                pay_mode={pay_mode}
                setMode={setMode}
                especes={especes}
                setEspeces={setEspeces}
                repCheques={repCheques}
                setRepCheques={setRepCheques}
                repVir={repVir}
                setRepVir={setRepVir} />}

                <TextField
                sx={{width:'30%', minWidth:'150px'}}
                margin="normal"
                label="N° Facture"
                value={num_facture}
                onChange={(e)=>setFactnum(e.target.value)}/>  
                <Typography variant="subtitle1" sx={{marginTop:'20px', marginBottom:'10px'}}>Importer la Facture</Typography>
                {facture_files.map((file, index)=>(
                    <Stack key={index} direction={'row'} spacing={2} alignItems={'center'}>
                        <input type='file' name='facture_file' accept='.pdf' onChange={(event)=>{
                            handleImport(event, index)
                        }} />
                        <IconButton onClick={()=>setFiles(old=>{let newf=[...old]; newf.splice(index, 1); return newf})}><ClearIcon /></IconButton>
                    </Stack>
                ))}
                {facture_files[facture_files.length-1]!=='' && facture_files.length<5 &&
                <Button variant="contained" sx={{alignSelf:'flex-start', marginLeft:'20px', marginTop:'10px', textTransform:'none', fontWeight:'bold'}} startIcon={<AddIcon/>} color="grey" 
                onClick={()=>setFiles(old=>{let newf=[...old]; newf.push(''); return newf})}>
                    Ajouter un fichier
                </Button>}

                {agent.level>2&&<>
                    <Typography>Si cette dépense n’a pas été réglée par la FEAM veuillez préciser l’origine des fonds:</Typography>
                    <FormControlLabel control={<Checkbox checked={is_petite_caisse} onChange={()=>setPetiteCaisse(old=>!old)} />} label="petite caisse église" />
                    {eglise.have_banque&&pay_mode.some(key=>['cheques', 'virement', 'cb'].includes(key))&&
                    <TextField select label="Banque église" value={banque} onChange={(e)=>setBanque(e.target.value)} sx={{marginTop:2}}>
                        {comptes.filter(cp=>cp.type==='banque').map(banque=><MenuItem key={banque.num} value={banque.num}>{banque.libelle}</MenuItem>)}
                    </TextField>}
                </>}

                <Button
                onClick={()=>SetOpen(true)}
                variant="contained"
                disabled={montant!==reptotal || montant<=0 || label==='' || date==='' || compteNum===''}
                sx={{ alignSelf:'flex-end', marginRight:'30px', marginTop:'15px', fontWeight:'bold' }}
                color="primary"
                >
                    Valider
                </Button>
            </Box>}

            <Dialog open={open} onClose={()=>SetOpen(false)}>
                <DialogTitle>Vous allez enregistrer la dépense suivante: </DialogTitle>
                {open&&<DialogContent>
                    <Typography>Date: { moment.utc(date).format('DD/MM/YYYY')}</Typography>
                    <Typography textTransform={'capitalize'}>Libellé: {label}</Typography>
                    <Typography>Compte débité: {compte.num_compte} {compte.libelle}</Typography>
                    <Typography>Montant de la dépense: {montant?.toFixed(2)}€</Typography>
                    <Typography>Mode de paiement:</Typography>
                    {especes>0 && <Typography>Espèces: {especes?.toFixed(2)}</Typography>}
                    {repCheques.filter(cheque => cheque.montant>0).length>0 && <Stack sx={{marginLeft: '30px'}}>
                        <Typography>Chèques:</Typography>
                        {repCheques.filter(cheque => cheque.montant>0).map((cheque, index)=>
                            <Typography key={index} sx={{marginLeft: '20px'}}>chèque {cheque.banque} n°{cheque.num_cheque !== '' ? cheque.num_cheque : '_______'} de {cheque.montant?.toFixed(2)}€</Typography>)}
                    </Stack>}
                    {repVir.montant>0 && <Typography sx={{marginLeft: '30px'}}>Virment du {repVir.date!== '' ? moment.utc(repVir.date).format('DD/MM/YYYY') : '_______'} référencé 
                    {repVir.ref !== '' ? ` ${repVir.ref}` : ' _______'} de {repVir.montant?.toFixed(2)}€</Typography>}
                    {facture_files.some(file => file!=='') ? 
                    <>
                        <Typography sx={{marginTop:'10px'}}>Facture:</Typography> 
                        {facture_files.filter(file => file!=='').map((file, index)=>(
                            <Typography key={index} fontSize={14} sx={{marginLeft:'15px'}}>{file.name}</Typography>
                        ))}
                    </> 
                    :<Typography textAlign='center' sx={{marginTop:'5px'}} color='carmine.main' fontSize={14}><span style={{fontWeight:'bold', fontSize:16}}>Attention!</span><br/>
                    Vous n'avez pas joint de facture pour cette dépense</Typography>}
                </DialogContent>}
                <DialogActions>
                    <Button onClick={()=>SetOpen(false)}>Annuler</Button>
                    <Button onClick={handleSubmit}>Confirmer</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={open_choice} onClose={()=>navigate("/")}>
                <DialogTitle>La dépense a bien été enregistrée</DialogTitle>
                <DialogActions>
                    <Button onClick={()=>window.location.reload()}>Enregistrer une autre dépense</Button>
                    <Button href="/">Accueil</Button>
                </DialogActions>
            </Dialog>
            <Backdrop open={sending}><CircularProgress color="inherit" /></Backdrop>
        </div>
    )
}